
const TaiwanFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" fill="none">
            <rect y="0.5" width="22" height="16" rx="2" fill="white" />
            <mask id="mask0_1325_7512" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                <rect y="0.5" width="22" height="16" rx="2" fill="white" />
            </mask>
            <g mask="url(#mask0_1325_7512)">
                <path fillRule="evenodd" clipRule="evenodd" d="M-1.04785 17.5664H23.0474V-0.566895H-1.04785V17.5664Z" fill="#FE3030" />
                <path fillRule="evenodd" clipRule="evenodd" d="M-1.04785 9.0331H11.5236V-0.566895H-1.04785V9.0331Z" fill="#0909B6" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.76211 6.1001L4.75985 7.23044L4.83614 5.70957L3.34243 5.78725L4.45259 4.76676L3.34243 3.74628L4.83614 3.82396L4.75985 2.30309L5.76211 3.43343L6.76438 2.30309L6.68809 3.82396L8.1818 3.74628L7.07164 4.76676L8.1818 5.78725L6.68809 5.70957L6.76438 7.23044L5.76211 6.1001Z" fill="white" />
            </g>
        </svg>
    )
}

export default TaiwanFlag